import React from 'react';

const Card = (props) => {
  const classes = 'help-page-card-container ' + props.className;
  return <div className={classes}>{props.children}</div>;
};

export default Card;
